export const featureInfoContent: Record<string, {
  description: string;
  benefits: string[];
  example?: string;
}> = {
  'Emails': {
    description: `Automate your invoice email communications with smart reminders and notifications. Set up emails to be sent automatically based on due dates, issue dates, or payment status to keep your customers informed and engaged.`,
    benefits: [
      `Send emails from your own domain`,
      `Better deliverability using our trusted email servers`,
      `Improve cash flow with timely payment reminders`,
      `Maintain consistent customer communication`,
      `Track all email activity in one place`,
    ],
    example: `Send a friendly reminder 7 days before an invoice is due, followed by another reminder on the due date, and a final notice 7 days after the due date if unpaid.`,
  },
  'Late Fees & Interest': {
    description: `Automatically calculate and apply late fees to overdue invoices. Configure percentage-based or fixed fees that are applied when invoices remain unpaid past their due date, helping incentivize timely payments.`,
    benefits: [
      `Apply on a per-invoice or per-customer basis`,
      `Encourage faster payment from customers`,
      `Automatically calculate fees based on your terms`,
      `Apply fees consistently across all overdue invoices`,
      `Track late fee revenue separately`,
    ],
    example: `Apply a 2% monthly interest charge to all invoices that remain unpaid 30 days after the due date, compounded daily.`,
  },
  'Statements': {
    description: `Schedule and automatically send account statements to your customers on a recurring basis. Statements provide a complete overview of all outstanding invoices, payments, and account balance.`,
    benefits: [
      `Keep customers informed of their account status`,
      `Reduce "I didn't know I owed anything" excuses`,
      `Automate monthly or weekly statement sending`,
      `Improve collections by showing the full picture`,
    ],
    example: `Send a monthly statement on the 1st of each month showing all outstanding invoices and recent payment activity.`,
  },
  'Escalations': {
    description: `Create manual tasks and reminders for your team when invoices reach critical stages. Escalations are organized by type: Calls for phone follow-ups, Stop Credit for account holds, and Legal for formal letters and legal action. Perfect for when automated emails aren't enough.`,
    benefits: [
      `Never miss follow-up on high-value overdue accounts`,
      `Escalate collections efforts at the right time`,
      `Create accountability with assigned tasks`,
      `Organize escalations by action type`,
      `Track completion of manual collection activities`,
    ],
    example: `Create a Call task when an invoice is 30 days overdue, a Stop Credit task at 60 days, and a Legal escalation at 90 days for formal collection letters.`,
  },
  'SMS': {
    description: `Send text message alerts for time-sensitive invoice communications. SMS messages have a 98% open rate and are perfect for urgent payment reminders or quick notifications.`,
    benefits: [
      `98% open rate compared to 20% for emails`,
      `Immediate delivery for urgent communications`,
      `Perfect for final payment reminders`,
      `Complement email reminders for better results`,
    ],
    example: `Send an SMS alert 3 days before a large invoice is due, and another text on the due date if it remains unpaid.`,
  },
  'Discounts': {
    description: `Automatically apply early payment discounts to incentivize customers to pay before the due date. Discounts are removed automatically if payment isn't received by the deadline.`,
    benefits: [
      `Improve cash flow by encouraging early payment`,
      `Automate discount application and removal`,
      `Reduce DSO (Days Sales Outstanding)`,
      `No manual intervention required`,
    ],
    example: `Offer a 2% discount if the invoice is paid upto 5 days before due date, automatically removing the discount if unpaid by that date.`,
  },
  'Quotes': {
    description: `Automate follow-up emails for quotes. Send reminders before quotes expire and follow-up messages to increase your quote-to-sale conversion rate.`,
    benefits: [
      `Increase quote acceptance rates`,
      `Stay top-of-mind with prospects`,
      `Reduce time spent on manual follow-ups`,
      `Track quote engagement and responses`,
    ],
    example: `Send a follow-up email 3 days after sending a quote, and a final reminder 2 days before the quote expires.`,
  },
  'Estimates': {
    description: `Automate follow-up emails for estimates. Send reminders before estimates expire and follow-up messages to increase your estimate-to-sale conversion rate.`,
    benefits: [
      `Increase estimate acceptance rates`,
      `Stay top-of-mind with prospects`,
      `Reduce time spent on manual follow-ups`,
      `Track estimate engagement and responses`,
    ],
    example: `Send a follow-up email 3 days after sending an estimate, and a final reminder 2 days before the estimate expires.`,
  },
};
